// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ba","top":"i_Bb","link":"i_Bc","active":"i_Bd","icon":"i_Be","label":"i_Bf","item":"i_Bg"};